import type { RouteRecordRaw } from "vue-router";
import { routeNames } from "@/router/constants";
import { loanRouteGuard } from "@/router/utils";
import { useIntl } from "@moroku/money-webapp-components";

const { t } = useIntl();

export const getLendingRoutes = (): RouteRecordRaw[] => [
  {
    path: "/loan-calculator",
    name: routeNames.LOAN_CALCULATORS,
    component: () => import("@/features/LoanApplication/LoanCalculatorsView.vue"),
    meta: {
      requiresAuth: false,
      title: t("loanApplication_loanCalculator_title"),
    },
  },
  {
    path: "/loan-application/:applicationId?",
    name: routeNames.LOAN_APPLICATION,
    component: () => import("@/features/LoanApplication/LoanApplicationView.vue"),
    props: route => ({ applicationId: route.params.applicationId }),
    beforeEnter: async (to, from, next) => {
      const loanNavigation = await loanRouteGuard(to);
      if (loanNavigation != undefined) {
        next(loanNavigation);
        return;
      }
      next();
    },
    meta: {
      title: t("loanApplication_title"),
    },
  },
  {
    path: "/loan-application/:applicationId?",
    name: routeNames.LOAN_APPLICATION,
    component: () => import("@/features/LoanApplication/LoanApplicationView.vue"),
    props: route => ({ applicationId: route.params.applicationId }),
    beforeEnter: async (to, from, next) => {
      const loanNavigation = await loanRouteGuard(to);
      if (loanNavigation != undefined) {
        next(loanNavigation);
        return;
      }
      next();
    },
    meta: {
      title: t("loanApplication_title"),
      requiresAuth: false, // auth is checked in beforeEnter
    },
  },
  {
    path: "/loans",
    name: routeNames.LOAN_APPLICATION_SPLASH,
    component: () => import("@/features/LoanApplication/LoanApplicationCtaView.vue"),
    meta: {
      requiresAuth: false,
      title: t("loanApplication_cta_title"),
    },
  },
  {
    path: "/loan-applications",
    name: routeNames.LOAN_APPLICATIONS,
    component: () => import("@/features/LoanApplication/LoanApplicationsView.vue"),
    meta: {
      title: t("loanApplications_title"),
    },
  },
  {
    path: "/broker/loan-applications",
    name: routeNames.BROKER_LOAN_APPLICATIONS,
    component: () => import("@/features/LoanApplication/BrokerLoanApplicationsView.vue"),
    meta: {
      requiresBroker: true,
      title: t("loanApplications_title"),
    },
  },
  {
    path: "/broker/loan-application/:applicationId?",
    name: routeNames.BROKER_LOAN_APPLICATION,
    component: () => import("@/features/LoanApplication/BrokerLoanApplicationView.vue"),
    props: route => ({ applicationId: route.params.applicationId }),
    beforeEnter: async (to, from, next) => {
      const loanNavigation = await loanRouteGuard(to);
      if (loanNavigation != undefined) {
        next(loanNavigation);
        return;
      }
      next();
    },
    meta: {
      requiresBroker: true,
      title: t("loanApplication_title"),
    },
  },
];
